import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { IconButton, Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { crearUrlWhatsApp, esRutaInformativaWhatsApp } from './whatsapp';
import './BotonWhatsApp.scss';

const BotonWhatsApp = () => {
  const { pathname } = useLocation();

  if (!esRutaInformativaWhatsApp(pathname)) {
    return null;
  }

  return (
    <Tooltip title="Contactar por WhatsApp" placement="left">
      <IconButton
        component="a"
        href={crearUrlWhatsApp()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactar al Teatro Bosch por WhatsApp"
        className="botonWhatsApp"
      >
        <WhatsAppIcon />
      </IconButton>
    </Tooltip>
  );
};

export default BotonWhatsApp;
